import React from 'react';
import { colors } from 'seedling/constants';

const LocationIcon = ({ color, size, ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 20 20"
    {...rest}
  >
    <path
      fill={color}
      d="M10.0009472,17.5473758
      L14.4015772,9.86285624 C14.9524897,9.01781679 15.25,8.03193171
      15.25,7 C15.25,4.10050506 12.8994949,1.75 10,1.75 C7.10050506,1.75
      4.75,4.10050506 4.75,7 C4.75,8.0799548 5.07596446,9.10919228
      5.67588075,9.97830405 L5.70994993,10.0324656
      L10.0009472,17.5473758 Z M3.25,7 C3.25,3.27207794 6.27207794,0.25
      10,0.25 C13.7279221,0.25 16.75,3.27207794 16.75,7 C16.75,8.3250509
      16.3667255,9.59514004 15.6807354,10.6450816 L10.6508822,19.430879
      C10.3626355,19.9343683 9.63637403,19.9339577 9.34869682,19.4301427
      L4.42275632,10.8032436 C3.66316346,9.69129061 3.25,8.37559151
      3.25,7 Z M10,9.75 C11.5187831,9.75 12.75,8.51878306 12.75,7
      C12.75,5.48121694 11.5187831,4.25 10,4.25 C8.48121694,4.25
      7.25,5.48121694 7.25,7 C7.25,8.51878306 8.48121694,9.75 10,9.75 Z
      M10,8.25 C9.30964406,8.25 8.75,7.69035594 8.75,7 C8.75,6.30964406
      9.30964406,5.75 10,5.75 C10.6903559,5.75 11.25,6.30964406 11.25,7
      C11.25,7.69035594 10.6903559,8.25 10,8.25 Z"
    />
  </svg>
);

LocationIcon.defaultProps = {
  size: 20,
  color: colors.mediumGrey,
};

export default LocationIcon;
